// Hooks
import { useIsAuthenticated } from 'modules/auth/hooks'

type IsAuthenticatedProps = {
  children: JSX.Element | Array<JSX.Element>
  include?: boolean
}

const IsAuthenticated = ({ children, include = false }: IsAuthenticatedProps) => {
  const isAuthenticated = useIsAuthenticated()
  return isAuthenticated || include ? <>{children}</> : null
}

export default IsAuthenticated
